import styled from '@emotion/styled'

import { Content } from '@cash-design-system/react'
import { ContentContainerStyles } from '@cash-web/support/ui-components'

const HelpContent = styled(Content)`
  ${ContentContainerStyles}
`

export default HelpContent
